/* eslint-disable no-use-before-define */
import React from 'react'
import { STATE_NAMES,  } from '../../../twd/twd'
import { getTooltipData } from './get-tooltip-data.js'
import { Detail } from './detail'
import { Loading } from './loading'
import { NotFound } from './not-found'

export const Loader = ({state,}) => {

    const [status, setStatus] = React.useState('loading')
    const [tooltipData, setTooltipData] = React.useState(null)

    React.useEffect(() => {
        let cancelled = false

        ;(async () => {
            let data_ = await getTooltipData({state})
            if (cancelled) return

            if (data_===undefined) {
                setStatus('failed')
                return
            }

            if (!data_) {
                setStatus('not-found')
                return
            }

            setStatus('found')
            setTooltipData(data_)
        })()

        return () => {
            cancelled = true
        }
    }, [])

    return <React.Fragment>
        <div className="container">
        { status==='loading' ? <Loading />
        : status==='not-found' ? <NotFound stateName={STATE_NAMES[state]} />
        : status==='found' ? <Detail {...tooltipData} />
        : null }
        </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/municipals/map/tooltip/loader.js